
















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import cCard from '@/components/default/Card.vue';
import { DxLoadPanel } from 'devextreme-vue/load-panel';

import projectsRepository from '@/services/projectsRepository';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

import customersRepository from '@/services/customers/customersRepository';
import PdfViewModal from '@/modules/shared/documents/pdfViewModal.vue';

import CreditNoteMailPopup from '../components/CreditNoteMailPopup.vue'; // Todo: refactor

import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import { DxDataGrid, DxColumn, DxEditing } from 'devextreme-vue/data-grid';

import { DxTabs } from 'devextreme-vue';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';
import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import AddArticleDialog from '@/modules/quotations/components/dialogs/AddArticleDialog.vue';
import {
  CreditNoteBlock,
  CreditNoteLine,
  CreditNotesClient,
  SendCreditNotesToAccountantCommand,
  UpdateCreditNoteCommand,
  CreditNoteDto,
  ArticleCategory,
  ArticleCategoryClient,
  Settings,
  ICreditNoteDto,
  AssignedContact,
  ProjectsClient,
  ProjectContactsClient,
} from '@/data/web-api-client';
import creditnotesService from '../creditnotesService';
import ProjectIsOnHoldPopup from '@/components/projects/ProjectIsOnHoldPopup.vue';
import CreditNoteDocument from '@/modules/creditnotes/components/CreditNoteDocument.vue';
import ArticleSummaryTable, { EntityType, SummaryItem } from '@/components/articles/articleSummaryTable.vue';
import { groupBy } from '@/helpers/Helper';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    cCard,
    DxDataGrid,
    DxColumn,
    DxEditing,
    PdfViewModal,
    DxLoadPanel,
    CreditNoteMailPopup,
    DxTabs,
    EventLogsTable,
    AddArticleDialog,
    ProjectIsOnHoldPopup,
    CreditNoteDocument,
    ArticleSummaryTable,
  },
})
export default class CreditNoteDetails extends Vue {
  entityType: EntityType = 'CreditNote';

  loading: boolean = false;
  saving: boolean = false;
  creditNote: CreditNoteDto | null = null;
  dirty: boolean = false;
  navIndex: number = 0;
  loadingDocument: boolean = false;
  disabled = false;

  blockToAddArticleTo: CreditNoteBlock | null = null;
  projectType: string | null = null;
  client = new CreditNotesClient(undefined, this.$axios);
  projectContactsClient: ProjectContactsClient = new ProjectContactsClient(undefined, this.$axios);
  public articleCategories: ArticleCategory[] = [];

  declare currency: any;

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    try {
      this.loading = true;
      this.creditNote = await this.client.getSingle(this.$route.params.id);
      this.articleCategories = await new ArticleCategoryClient(undefined, this.$axios).get();

      this.disabled = this.creditNote.projectIsOnHold!;

      if (this.creditNote.projectId) {
        const project = (await projectsRepository.getSingle(this.creditNote.projectId)).data;

        this.projectType = project.type;
      }
    } catch (err) {
      notificationService.failedToLoad();
    } finally {
      setTimeout(() => {
        this.loading = false;

        if (this.$route.query.checkProjectOnHold === 'true' && this.creditNote?.projectIsOnHold) {
          this.projectIsOnHoldPopup.show();
        }
      }, 200);
    }
  }

  async showDocument() {
    if (!this.creditNote) {
      return;
    }

    try {
      this.loadingDocument = true;
      const result = await this.client.download(this.creditNote.id!);
      const url = window.URL.createObjectURL(result.data);
      (this.$refs.PdfViewModal as PdfViewModal).show(url);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loadingDocument = false;
    }
  }

  sendMail() {
    (this.$refs.mailPopup as CreditNoteMailPopup).open();
  }

  blockUpdated() {
    this.dirty = true;
  }

  createBlock() {
    if (!this.creditNote) {
      throw Error('Creditnota is null');
    }

    const name = prompt('Geef de naam van de nieuwe blok op', '');

    if (name && name !== '') {
      this.creditNote?.blocks?.push(
        new CreditNoteBlock({
          showTitle: true,
          showTotals: false,
          title: name,
          lines: [],
        })
      );
    }
  }

  removeBlock(index: number) {
    if (!this.creditNote?.blocks) {
      return;
    }

    const block = this.creditNote?.blocks[index];

    if (!block) {
      return;
    }

    if (confirm(`Ben je zeker dat je de blok ${block?.title} wilt verwijderen?`)) {
      (this.creditNote?.blocks as any[]).splice(index, 1);
    }
  }

  updateNotes(e: any) {
    const promptValue = prompt('Opmerking', e.row.data.remarks);
    if (promptValue) {
      e.row.data.remarks = promptValue;
      this.blockUpdated();
    }
  }

  async save() {
    try {
      this.saving = true;
      await this.client.update(this.creditNote!.id!, UpdateCreditNoteCommand.fromJS(this.creditNote!));
      this.dirty = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.dirty) {
      if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  public openAddArticle(block: any) {
    const dialog = this.$refs.AddArticleDialog as AddArticleDialog;

    dialog.show = true;

    this.blockToAddArticleTo = block;
  }

  public addArticle(input: { article: IArticle; data: { articleId: string; quantity: number } }) {
    const dialog = this.$refs.AddArticleDialog as AddArticleDialog;

    try {
      dialog.updating = true;

      const articleVariant = input.article.variants && input.article.variants.length > 0 ? input.article.variants[0] : undefined;

      if (!articleVariant) {
        throw Error('Variant not found');
      }

      const salesPrice = (articleVariant as IArticleVariant).salesPrices.find((sp) => sp.type == this.projectType);

      if (!salesPrice) {
        throw Error('Salesprice not found');
      }

      const creditNoteLine = new CreditNoteLine({
        articleId: input.data.articleId,
        variant: articleVariant ? articleVariant.name : '',
        quantity: input.data.quantity,
        price: salesPrice.price,
        description: `${input.article.name}: ${input.article.description}`,
        remarks: '',
        total: input.data.quantity * salesPrice.price,
      });

      const block = this.creditNote?.blocks?.find((b: CreditNoteBlock) => b === this.blockToAddArticleTo);

      if (!block) {
        throw Error('Block not found');
      }

      if (!block.lines) {
        block.lines = [];
      }

      block.lines.push(creditNoteLine);

      dialog.show = false;
    } catch (err) {
      notificationService.showErrorMessage(`Artikel kon niet toegevoegd worden. Reden: ${err}`);
    } finally {
      dialog.updating = false;
    }
  }

  async sendToAccountant() {
    const creditNoteIds = [this.creditNote!.id!];

    if (creditNoteIds.length === 0) {
      return;
    }

    const command = new SendCreditNotesToAccountantCommand({
      creditNoteIds: [...creditNoteIds],
    });

    try {
      await this.client.sendToAccountant(command);

      notificationService.showNotification('De creditnota wordt in de achtergrond verstuurd naar de boekhouding', 'info');
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  get codeSummary() {
    const summaryByCategories = this.settings.summaryInCategories;
    let result: SummaryItem[] = [];
    if (!this.creditNote || !this.creditNote.blocks) {
      return result;
    }
    if (summaryByCategories) {
      const allLinesWithoutDefaultBlock = this.creditNote.blocks.filter((b) => b.lines && b.title != 'Standaardkosten').flatMap((b) => b.lines);
      const allDefaultBlockLines = this.creditNote.blocks.filter((b) => b.lines && b.title == 'Standaardkosten').flatMap((b) => b.lines);

      const groupedLinesByCategory: Map<string, CreditNoteLine[]> = groupBy(allLinesWithoutDefaultBlock, 'articleCategoryId');

      for (const [key, values] of groupedLinesByCategory) {
        var groupedLines: Map<string, CreditNoteLine[]> = groupBy(values, 'description');
        for (const [articleId, lines] of groupedLines) {
          if (lines.length == 0) continue;

          let line = lines[0];

          const quantitySum = lines.reduce((a: number, { quantity }) => a + quantity!, 0);
          const totalSum = lines.reduce((a: number, { total }) => a + total!, 0);

          const resultIndex = result.findIndex((o) => o.articleId === line.articleId);
          if (resultIndex === -1) {
            result.push({
              articleId: line.articleId!,
              description: line.description!,
              quantity: quantitySum,
              unitPrice: totalSum!,
              articleCategoryId: line.articleCategoryId!,
            });
          } else {
            result[resultIndex].quantity += quantitySum;
            result[resultIndex].unitPrice += totalSum!;
          }
        }
      }

      const nullCatLines = result.filter((r) => r.articleCategoryId == null);
      const catLines = result.filter((r) => r.articleCategoryId != null);
      result = [...catLines, ...nullCatLines];

      var groupedDefaultBlockLines: Map<string, CreditNoteLine[]> = groupBy(allDefaultBlockLines, 'description');
      for (const [articleId, lines] of groupedDefaultBlockLines) {
        if (lines.length == 0) continue;

        let line = lines[0];

        const quantitySum = lines.reduce((a: number, { quantity }) => a + quantity!, 0);
        const totalSum = lines.reduce((a: number, { total }) => a + total!, 0);

        const resultIndex = result.findIndex((o) => o.articleId === line.articleId && o.description === line.description);
        if (resultIndex === -1) {
          result.push({
            articleId: line.articleId!,
            description: line.description!,
            quantity: quantitySum,
            unitPrice: totalSum!,
            articleCategoryId: line.articleCategoryId!,
          });
        } else {
          result[resultIndex].quantity += quantitySum;
          result[resultIndex].unitPrice += totalSum!;
        }
      }

      result.forEach((resultItem) => {
        resultItem.unitPrice = resultItem.unitPrice / resultItem.quantity;
      });

      return result;
    }

    // summary not grouped by categories

    for (const block of this.creditNote.blocks.filter((b) => b.lines)) {
      for (const line of block.lines!) {
        if (line.articleId && line.articleId !== '' && line.quantity && line.total) {
          const resultIndex = result.findIndex((o) => o.articleId === line.articleId && o.description === line.description);
          if (resultIndex === -1) {
            result.push({
              articleId: line.articleId,
              description: line.description!,
              quantity: line.quantity,
              unitPrice: line.total,
              articleCategoryId: line.articleCategoryId!,
            });
          } else {
            result[resultIndex].quantity += line.quantity;
            result[resultIndex].unitPrice += line.total;
          }
        }
      }
    }

    result.forEach((resultItem) => {
      resultItem.unitPrice = resultItem.unitPrice / resultItem.quantity;
    });

    return result;
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-info-circle', text: 'Basis info' },
      { icon: 'fas fa-info-circle', text: 'Samenvatting' },
      { icon: 'fas fa-file-pdf', text: 'Document' },
      { icon: 'fas fa-history', text: 'Geschiedenis' },
    ];
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectId: this.$route.params.id,
      type: EventLogsObjectType.CreditNote,
    };
  }

  get totalExcl() {
    let total: number = 0;

    this.creditNote?.blocks?.forEach((block: any) => {
      block.lines.forEach((line: any) => {
        total += line.quantity * line.price;
      });
    });

    return total;
  }

  get totalTax() {
    if (!this.creditNote?.taxRate) {
      return 0;
    }

    return (this.totalExcl * this.creditNote.taxRate) / 100;
  }

  get totalIncl() {
    return this.totalExcl + this.totalTax;
  }

  get projectsOptions() {
    const self = this;
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          key: 'id',
          load: async (loadOptions) => {
            if (Array.isArray(loadOptions.filter) && loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {
              return {
                data: [],
                totalCount: 0,
              };
            }

            if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
              loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
            }

            const result = await projectsRepository.lookup(loadOptions);

            return {
              data: result.data.data,
              totalCount: result.data.totalCount,
            };
          },
          byKey: async (val: any) => {
            return projectsRepository.getSingle(val).then((result: any) => {
              return result.data;
            });
          },
        }),
        paginate: true,
      }),
      valueExpr: 'id',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get contactsOptions() {
    const self = this;
    if (self.creditNote!.projectId && self.creditNote!.projectId !== null) {
      return {
        dataSource: new dxCustomStore({
          key: 'id',
          load: async (loadOptions: any) => {
            const clients = await this.projectContactsClient.getContacts(self.creditNote!.projectId!).then((assignedContacts: AssignedContact[]) => {
              return assignedContacts.filter((contact: AssignedContact) => contact.sendInvoice);
            });

            return clients.map((client: AssignedContact) => client.contact);
          },
          byKey: async (val: any) => {
            const clients = await this.projectContactsClient.getContacts(self.creditNote!.projectId!).then((assignedContacts: AssignedContact[]) => {
              return assignedContacts.filter((contact: AssignedContact) => contact.contact != undefined && contact.contact.id == val && contact.sendInvoice);
            });

            return clients.map((client: AssignedContact) => client.contact);
          },
        }),
        displayExpr: 'displayName',
        searchEnabled: true,
        disabled: self.creditNote ? self.creditNote.status! > 1 : true,
      };
    } else {
      return {
        dataSource: new DataSource({
          store: new dxCustomStore({
            load: async (loadOptions) => {
              const result = await customersRepository.get(loadOptions);
              return {
                data: result.data,
              };
            },
            byKey: (val: any) => {
              return val;
            },
          }),
          paginate: true,
        }),
        displayExpr: 'displayName',
        searchEnabled: true,
        showClearButton: true,
        disabled: self.creditNote ? self.creditNote.status! > 1 : true,
      };
    }
  }

  get customerContactsOptions() {
    const self = this;
    if (self.creditNote!.projectId && self.creditNote!.projectId !== null) {
      return {
        dataSource: new dxCustomStore({
          key: 'id',
          load: async (loadOptions: any) => {
            const customers = await new ProjectsClient(undefined, this.$axios).getProjectsContacts(self.creditNote!.projectId!).then((assignedContacts: AssignedContact[]) => {
              return assignedContacts.filter((contact: AssignedContact) => contact.sendInvoice);
            });

            return customers.map((customer: AssignedContact) => customer.contact);
          },
          byKey: async (val: any) => {
            const customers = await new ProjectsClient(undefined, this.$axios).getProjectsContacts(self.creditNote!.projectId!).then((assignedContacts: AssignedContact[]) => {
              return assignedContacts.filter((contact: AssignedContact) => contact.contact != undefined && contact.contact.id == val && contact.sendInvoice);
            });

            return customers.map((customer: AssignedContact) => customer.contact);
          },
        }),
        displayExpr: 'displayName',
        searchEnabled: true,
        showClearButton: true,
        disabled: self.creditNote ? self.creditNote.status! > 1 : true,
      };
    } else {
      return {
        dataSource: new DataSource({
          store: new dxCustomStore({
            load: async (loadOptions) => {
              const result = await customersRepository.get(loadOptions);
              return {
                data: result.data,
              };
            },
            byKey: (val: any) => {
              return val;
            },
          }),
          paginate: true,
        }),
        displayExpr: 'displayName',
        searchEnabled: true,
        disabled: self.creditNote ? self.creditNote.status! > 1 : true,
      };
    }
  }


  get creditNotesStatusses() {
    return creditnotesService.getStatusOptions();
  }

  get taxrates() {
    return [
      { value: 0, text: '0%' },
      { value: 6, text: '6%' },
      { value: 21, text: '21%' },
    ];
  }

  get settings(): Settings {
    return this.$store.getters['settings/data'];
  }

  get lineColumns() {
    const self = this;
    return [
      {
        dataField: 'description',
        caption: 'Beschrijving',
        validationRules: [
          {
            type: 'required',
            message: 'Dit veld is verplicht!',
          },
        ],
      },
      {
        dataField: 'quantity',
        caption: 'Hoeveelheid',
        alignment: 'left',
        dataType: 'number',
        calculateCellValue(value: any) {
          if (value.quantity) {
            return Math.round(value.quantity * 1000) / 1000;
          }
          return 0;
        },
        validationRules: [
          {
            type: 'required',
            message: 'Dit veld is verplicht!',
          },
        ],
      },
      {
        dataField: 'price',
        caption: 'Prijs',
        dataType: 'number',
        alignment: 'left',
        format: {
          type: 'currency',
          precision: 2,
        },
        validationRules: [
          {
            type: 'required',
            message: 'Dit veld is verplicht!',
          },
        ],
      },
      {
        alignment: 'left',
        formItem: {
          visible: false,
        },
        caption: 'Totaal',
        cssClass: '',
        format: {
          type: 'currency',
          precision: 2,
        },
        calculateCellValue(value: any) {
          if (value.quantity && value.price) {
            return value.quantity * value.price;
          }
          return 0;
        },
      },
      {
        dataField: 'remarks',
        caption: 'Opmerkingen',
        dataType: 'text',
        visible: true,
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Opmerking',
            icon: 'fas fa-comment-dots',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.isCompleted;
            },
            onClick: this.updateNotes,
          },
          'edit',
          'delete',
        ],
      },
    ];
  }

  get projectIsOnHoldPopup() {
    return this.$refs.projectIsOnHoldPopup as ProjectIsOnHoldPopup;
  }

  @Watch('creditNote', { deep: true })
  onCreditNoteChanged() {
    if (!this.loading) {
      this.dirty = true;
    }
  }
}
